import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.FMIS_SERVER_PREFIX}/budget-approval`;
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    bulkStatus: () => `${RESOURCE_ENDPOINT}/bulk-status`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
    status: (id: Number) => `${RESOURCE_ENDPOINT}/${id}/status`,
    previousQuarterData: () => `${RESOURCE_ENDPOINT}/previousQuarterData`,
    codeWiseList: () => `${RESOURCE_ENDPOINT}/code-wise`,
    codeWiseOffices: (economicCodeId: any) => `${RESOURCE_ENDPOINT}/code-wise/${economicCodeId}/offices`,
    codeWiseAllocate: (economicCodeId: any) => `${RESOURCE_ENDPOINT}/code-wise/${economicCodeId}/allocate`,
    sendBack: (id: Number) => `${RESOURCE_ENDPOINT}/${id}/send-back`,
};

export default class BudgetApprovalApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();

        return HttpService.get(url, params, headers);
    };

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    };

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    };

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    };

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    };

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    };

    public bulkStatus = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulkStatus();
        return HttpService.post(url, payload, params, headers);
    };

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    };

    public status = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.status(id);
        return HttpService.put(url, payload, params, headers);
    };

    public previousQuarterData = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.previousQuarterData();
        return HttpService.get(url, params, headers);
    };

    public codeWiseList = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.codeWiseList();
        return HttpService.get(url, params, headers);
    };

    public codeWiseOffices = (economicCodeId: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.codeWiseOffices(economicCodeId);
        return HttpService.get(url, params, headers);
    };

    public codeWiseStoreOffices = (economicCodeId: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.codeWiseOffices(economicCodeId);
        return HttpService.post(url, payload, params, headers);
    };

    public codeWiseAllocate = (economicCodeId: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.codeWiseAllocate(economicCodeId);
        return HttpService.put(url, payload, params, headers);
    };

    public sendBack = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.sendBack(id);
        return HttpService.put(url, payload, params, headers);
    };
}
